export default {
      id: "ic_empty_star-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_empty_star-usage",
      toString: function () {
        return this.url;
      }
    }